import axiosInst from '../../libs/axios/axios'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  userMeInfo: null
}
const getters = {
  returnUserMeInfo (state) {
    return state.userMeInfo
  }
}
const mutations = {
  userMeInfo (state, info) {
    state.userMeInfo = info
  }
}


const actions = {
  userMeInfo (store) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/user/me/`).then(response => {
        store.commit('userMeInfo', response.data)
        localStorage.setItem('userMeInfo', JSON.stringify(response.data))
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  editUserInfo (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/user/`, data).then(response => {
        store.dispatch('refreshToken')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  notificationSettings (_, info) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/user/notification-settings/`, info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  validateNotificationSettings (_, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/user/notification-settings/${info}/validate/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
